import { Component, ElementRef, OnInit, Input, ViewChild } from '@angular/core';
import { CarouselComponent, SlidesOutputData } from 'ngx-owl-carousel-o';
import { servicesData } from '../../data/service/services_data';

@Component({
  selector: 'service-img',
  templateUrl: './service-img.component.html',
  styleUrls: ['./service-img.component.scss']
})
export class ServiceImgComponent implements OnInit {

  @Input() img: string;
  @Input() theme: string;
  @Input() service: string;

  @ViewChild('owlCar') nameInputRef: ElementRef;
  activeSlides: SlidesOutputData;
  flag: boolean = false;
  previous: number = 1;

  constructor() { }

  ngOnInit() {

    if (this.service == 'calculator') {
      this.buildsync = servicesData.calculator.images;
      this.navsync = servicesData.calculator.navsync;
    } else if (this.service == 'maintenance') {
      this.buildsync = servicesData.maintenance.images;
      this.navsync = servicesData.maintenance.navsync;
    } else if (this.service == 'datascience') {
      this.buildsync = servicesData.datascience.images;
      this.navsync = servicesData.datascience.navsync;
    } else if (this.service == 'development') {
      this.buildsync = servicesData.development.images;
      this.navsync = servicesData.development.navsync;
    } else if (this.service == 'enterprise') {
      this.buildsync = servicesData.enterprise.images;
      this.navsync = servicesData.enterprise.navsync;
    } else {
      this.buildsync = servicesData.optimization.images;
      this.navsync = servicesData.optimization.navsync;
    }
  }

  buildsync: any;
  navsync: any;

  slidesPerPage = 1;
  sync1 = {
    items: 1,
    smartSpeed: 2000,
    slideSpeed: 1000,
    nav: false,
    autoplay: true,
    autoplayTimeout: 8000,
    dots: false,
    loop: true,
    navText: ['<svg width="100%" height="100%" viewBox="0 0 11 20"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M9.554,1.001l-8.607,8.607l8.607,8.606"/></svg>', '<svg width="100%" height="100%" viewBox="0 0 11 20" version="1.1"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"/></svg>'],
  }

  sync2 = {
    items: this.slidesPerPage,
    autoplay: true,
    dots: true,
    nav: false,
    smartSpeed: 1000,
    slideSpeed: 2000,
    autoplayTimeout: 8000,
    loop: true,
    slideBy: this.slidesPerPage,
    responsiveRefreshRate: 100
  }

  changeSlide(event: any, owlCar1: CarouselComponent) {

    let startPosition = event.startPosition + 1 as number;

    if (this.flag == true) {

      if (startPosition == 1) {
        document.getElementById('serviceStep' + this.previous).classList.remove('filter-element');
        document.getElementById('serviceStep' + startPosition).classList.add('filter-element');

        this.previous = 1;
      } else {

        document.getElementById('serviceStep' + this.previous).classList.remove('filter-element');
        document.getElementById('serviceStep' + startPosition).classList.add('filter-element');

        this.previous = startPosition;
      }
    } else this.flag = true;
  }

  getData(data: SlidesOutputData) {
    this.activeSlides = data;
  }

  slideTo(data) {
    this.activeSlides = data;

  }

}
